import FaqSection from "@/components/sections/products/shared/faq";
import { linkifyPhrase } from "@/components/sections/products/shared/faq/linkify";
import { RESIDENTIAL_PRODUCT_FAQS } from "./data";

const AUP_LINK = { phrase: "Acceptable Use Policy", href: "/legal/acceptable-use-policy" };

const faqs = RESIDENTIAL_PRODUCT_FAQS.map((faq) => ({
  ...faq,
  a: typeof faq.a === "string" ? linkifyPhrase(faq.a, AUP_LINK) : faq.a,
}));

export default function ResidentialProductFaq() {
  return (
    <FaqSection
      faqs={faqs}
      heading="Residential Proxy FAQs"
      description="Everything you need to know about Proxidize residential proxies. Can't find what you're looking for?"
      headingId="residential-product-faq-heading"
    />
  );
}
